module.exports = __webpack_public_path__ + "img/youtube-logo.b9a4be12.svg";